// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1752":"3ebfdf8c","1886":"3ebfdf8c","3163":"3ebfdf8c","8312":"c1153fa0"}[chunkId] + ".chunk.css";
};